/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RilascioBudgetRevoca } from './rilascio-budget-revoca';
import { ModalitaEstensione } from './modalita-estensione';
import { CriterioSpareggioForm } from './criterio-spareggio-form';
import { TipoGraduatoria } from './tipo-graduatoria';
import { LimiteAssegnazione } from './limite-assegnazione';
import { DirezioneOrdinamento } from './direzione-ordinamento';
import { OrdinamentoPariPunteggio } from './ordinamento-pari-punteggio';
import { ContributoFasciaForm } from './contributo-fascia-form';
import { RigaConfineModalita } from './riga-confine-modalita';
import { TipoCalcoloContributo } from './tipo-calcolo-contributo';


export interface TipoPraticaGraduatoriaForm { 
    version: number;
    tipo_graduatoria?: TipoGraduatoria;
    direzione_ordinamento?: DirezioneOrdinamento;
    ordinamento_pari_punteggio?: OrdinamentoPariPunteggio;
    limite_assegnazione?: LimiteAssegnazione;
    modalita_estensione?: ModalitaEstensione;
    tipo_calcolo_contributo?: TipoCalcoloContributo;
    contributo_massimo?: number;
    budget_totale?: number;
    numero_massimo_beneficiari?: number;
    moltiplicatore_punteggio?: number;
    contributo_fasce?: Array<ContributoFasciaForm>;
    riga_confine_modalita?: RigaConfineModalita;
    criteri_spareggio?: Array<CriterioSpareggioForm>;
    revoca_rilascio_budget?: RilascioBudgetRevoca;
}



